import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Route } from 'react-router-dom';
import {
  Button,
  DialogActions,
  IconButton,
  Paper,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  withStyles,
} from 'material-ui';
import DeleteIcon from 'material-ui-icons/Delete';
import LockIcon from 'material-ui-icons/Lock';
import BlockIcon from 'material-ui-icons/Block';
import Table from 'material-ui/Table';
import * as actions from '../user.actions';
import { getAllUsers } from '../user.selectors';
import { roleToString } from '../../../utils/user-utils';
import { formatDate } from '../../../utils/date-utils';
import AddUserDialog from './AddUserDialog';
import RemoveUserDialog from './RemoveUserDialog';
import { PageAppBar } from '../../core/components/';
const styles = theme => ({
  content: {
    maxWidth: 1040,
    margin: '0 auto',
    boxSizing: 'border-box',
  },
  narrow: {
    width: '13.5%',
  },
  cellLabel: {
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingTop: '20px',
  },
  wrapper: {
    padding: theme.spacing.unit * 2,
  },
});

const columns = ['Nimi', 'Liittynyt', 'Sähköposti', 'Käyttöoikeudet', 'Status', ''];

class UserListPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addUserOpen: false,
      removeUserOpen: false,
      userToDelete: 0,
    };
  }
  showAddUser = () => {
    this.setState({
      addUserOpen: true,
    });
  };
  handleAddUserClose = () => {
    this.setState({ addUserOpen: false });
  };
  componentDidMount = () => {
    const { getUsers } = this.props;
    getUsers();
  };
  showDeleteUser = userId => {
    this.setState({ removeUserOpen: true });
    this.props.history.push(`/users/removeuser/${userId}`);
  };
  closeDeleteUser = () => {
    this.setState({ removeUserOpen: false });
  };

  splitActiveUsers = (users) => {
    let activeUsers = []
    let deactivatedUsers = []
    users.forEach((user)=>{
      if(user.disabled){
        deactivatedUsers.push(user)
      }else{
        activeUsers.push(user)
      }
    })
    return {activeUsers, deactivatedUsers}
  }

  sortByRole = (users) => {

    const roleRank = (role) => {
      switch (role) {
        case 'superuser':
          return 0;
        case 'department':
          return 1;
        case 'inspector':
          return 2;
        case 'guest':
          return 3;
        default:
          return 99;
      }
    }
    users.sort((a,b) => {
      a = roleRank(a.role);
      b = roleRank(b.role);
      return (a === b)? 0 : (a>b)? 1 : -1;
    })
    return users
  }


  render() {
    const { classes, allUsers, backPath, online } = this.props;
    //FIXME: responsive: mobile tables

    let {activeUsers,deactivatedUsers} = this.splitActiveUsers(allUsers)
    activeUsers = this.sortByRole(activeUsers)
    deactivatedUsers = this.sortByRole(deactivatedUsers)
    const users = activeUsers.concat(deactivatedUsers)

    return (
      <div className={classes.content}>
        <PageAppBar title={'Käyttäjähallinta'} backPath={backPath} />
        <Paper className={classes.wrapper}>
          <Table>
            {columns.length > 0 && (
              <TableHead>
                <TableRow>
                  {columns.map((prop, index) => {
                    return (
                      <TableCell key={index}>
                        <div className={classes.cellLabel}>{prop}</div>
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
            )}
            <TableBody>
              {users.map((user, index) => {
                user.disabled = user.disabled || false
                var regexp = RegExp(/^(serverrender).*(@hiq.*)$|^(wihuri.admin@hiq.fi)$|^(avesco.admin@hiq.fi)$/g)
                var forbiddenEmail = user.email.match(regexp) ? true : false;
                return (
                  <TableRow key={index}>
                    <TableCell>{user.firstName + ' ' + user.lastName}</TableCell>
                    <TableCell>{formatDate(user.createdAt)}</TableCell>
                    <TableCell>{user.email}</TableCell>
                    <TableCell>{roleToString(user.role)}</TableCell>
                    <TableCell>{user.disabled ? 'Deaktivoitu' : 'Aktiivinen'}</TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => this.showDeleteUser(user._id)}
                        title="Poista käyttäjä"
                        disabled={!online || user.disabled || forbiddenEmail}
                      >
                        {user.disabled ? <BlockIcon /> : forbiddenEmail ? <LockIcon /> : <DeleteIcon />}
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <DialogActions>
            <Button raised disabled={!online} onClick={this.showAddUser} color="primary">
              Lisää käyttäjiä
            </Button>
          </DialogActions>
          <AddUserDialog open={this.state.addUserOpen} onRequestClose={this.handleAddUserClose} />
          <Route
            exact
            path="/users/removeuser/:id"
            parentPath="/"
            render={({ match, location, history }) => (
              <RemoveUserDialog
                open={this.state.removeUserOpen}
                userToDelete={this.state.userToDelete}
                onRequestClose={this.closeDeleteUser}
              />
            )}
          />
        </Paper>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const allUsers = getAllUsers(state);
  const online = state.offline.online;
  return {
    allUsers,
    online,
  };
};

export default withRouter(connect(mapStateToProps, Object.assign({}, actions))(withStyles(styles)(UserListPage)));



// WEBPACK FOOTER //
// ./src/modules/user/components/UserListPage.js